import * as React from 'react';
import { FullComposeForm } from 'owa-calendar-full-compose-view';
import { Modal } from '@fluentui/react/lib/Modal';
import { observer } from 'mobx-react-lite';
import { presentDiscardClosureConfirmation } from 'owa-calendar-compose-form-actions';
import { isOpxAndTeams } from 'owa-opx';
import { lazyIsFullComposeOpen } from 'owa-calendar-compose-form-store';

const styles = require('./FullComposeRenderer.scss');

/**
 * Component for rendering full compose form
 */
const FullComposeRenderer = observer(function FullComposeRenderer() {
    const isFullComposeOpen = lazyIsFullComposeOpen.tryImportForRender()?.() ?? false;

    if (!isFullComposeOpen) {
        return null;
    }

    if (isOpxAndTeams()) {
        return <FullComposeForm />;
    } else {
        return (
            <Modal
                allowTouchBodyScroll={true}
                isOpen={true}
                isBlocking={false}
                onDismiss={presentDiscardClosureConfirmation}
                containerClassName={styles.dialog}
                forceFocusInsideTrap={
                    false /* forceFocusInsideTrap is not compatible with iframes and dialogs (both used by add-ins) */
                }>
                <FullComposeForm />
            </Modal>
        );
    }
});

export default FullComposeRenderer;
